import React, { } from 'react';
import { Tooltip } from 'antd';


const DcrFieldMapResolver = ({ value }) => value.fieldApb ? <Tooltip title={value.field}>{value.fieldApb}</Tooltip> : value.field;

export default DcrFieldMapResolver;
